import React from 'react';
import { motion } from 'framer-motion';

const pageVariant = {
  initial: {
    opacity: 1
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.25
    }
  }
}

export default function AnimatedPage({children}) {
  return (
    <motion.div
      variants={pageVariant}
      initial="initial"
      animate="animate"
      exit="exit"
      className="page d-flex flex-column"
    >
      {children}
    </motion.div>
  )
}
